var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPatientExperienceBankIcon = function SvgPatientExperienceBankIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    style: {
      width: 20,
      height: 20
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--sidebar-menu-item-color)",
    d: "M8.042 8.93c-.079.54-.093.722.128.958l.581.613a4.5 4.5 0 0 1 1.69-1.868l-.031-.046c-.225-.35-.387-.603-1.004-.502-1.214.197-1.304.416-1.356.784z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--sidebar-menu-item-color)",
    fillRule: "evenodd",
    d: "M8.368 13.334h-.564c-2.874 0-5.204-2.388-5.204-5.333a5.38 5.38 0 0 1 1.454-3.698.9.9 0 0 1 .2.286c.133.304.133.62.133.897 0 .219 0 .427.068.578.094.206.499.292.856.37l.013.003c.123.027.25.054.366.087.329.093.584.397.788.639.086.101.21.25.273.286a.7.7 0 0 0 .19-.332c.039-.146.028-.276-.03-.346-.364-.44-.344-1.287-.231-1.599.177-.493.73-.456 1.134-.429h.004c.149.01.29.02.394.005.308-.039.453-.411.543-.642.029-.075.052-.135.074-.165.172-.242.666-.595 1.026-.843 1.855.816 3.153 2.456 3.153 4.654v.262a4.3 4.3 0 0 1 1.294.303q.008-.158.008-.316c0-3.681-2.912-6.667-6.504-6.667S1.301 4.32 1.301 8.001s2.912 6.667 6.504 6.667q.492-.001.964-.074l.026-.004a4.5 4.5 0 0 1-.426-1.257",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--sidebar-menu-item-color)",
    d: "M11.177 14.677 9.758 15l.315-1.455a2.8 2.8 0 0 1-.315-1.294c0-1.52 1.202-2.75 2.684-2.75s2.683 1.232 2.683 2.75-1.203 2.75-2.685 2.75a2.6 2.6 0 0 1-1.263-.323"
  })));
};
export default SvgPatientExperienceBankIcon;